//#region import libraries
import React, { useEffect, useState } from 'react';

// icons
import { FiRefreshCcw } from "react-icons/fi";
import { FaCirclePlus } from "react-icons/fa6";

// styling
import { Colors, Spacing } from '_styles';

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectGetArrivalBookingsStatus, selectGetDepartureBookingStatus, selectTaskStatusFilter, setTaskStatusFilter } from '_redux/slices/timeline/timeline-data';
import { resetAddEmployeeForm } from "_redux/slices/timeline/employees";
import { selectSelectedTimeline, setBookingType, selectBookingType } from "_redux/slices/timeline/timeline-areas";
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// custom compoennts
import { CustomSpinner, AddEmployeeIcon } from '_atoms';
import PaginationV2 from '_components/organisms/prm-bookings/pagination2';
import AddEmployeeForm from "../employee-components/add-employee-form";
import ActionsModal from '_components/molecules/Modals/actions-modal';
import JobTypeDropdown from './job-type-dropdown';
import { FaPlus } from "react-icons/fa";

// tremor
import { Button } from 'react-bootstrap';
import { useInterval } from '_utils/hooks';

// moment
import moment from 'moment';

// select
import Select from "react-select";

// utils
import { BookingTypesFilters, SaudiDomesticAirports } from "_utils/timeline-constants";
import { selectPreBoard, selectRampBookings } from '_redux/slices/timeline/timeline-control';


//#endregion
const JobListToolbar = (props) => {

    //#region redux
    const dispatch = useDispatch();

    const dbUser = useSelector(selectFirebaseInfo);                               // logged in user
    const getArrivalBookingsStatus = useSelector(selectGetArrivalBookingsStatus);
    const getDepartureBookingStatus = useSelector(selectGetDepartureBookingStatus);
    const selectedTimeline = useSelector(selectSelectedTimeline);            // the selected timeline
    const bookingType = useSelector(selectBookingType);                      // select bookingType (departures,arrivals,all)
    const usedTheme = useSelector(selectUsedTheme);
    const preBoard = useSelector(selectPreBoard);                       // status of auto accept unplaned task switch
    const rampBookings = useSelector(selectRampBookings); // status of RampBookings switch

    //#endregion

    //#region local states
    const [lastUpdate, setLastUpdate] = useState(new Date())
    const [showAddModal, setShowAddModal] = useState(false);                 // show add employee modal
    const [bookingsTypes, setBookingsTypes] = useState([]);                 // array of bookings types to preview(all, arrivals,....)
    //#endregion

    //#region useEffect

    useEffect(() => {
        setLastUpdate(new Date());
    }, [])

    useEffect(() => {

        let tempBookingsTypes = BookingTypesFilters;
        if (!preBoard) {
            tempBookingsTypes = tempBookingsTypes.filter((type) => type.value !== "boarding");
        }
        if (!rampBookings) {
            tempBookingsTypes = tempBookingsTypes.filter((type) => type.value !== "ramp");
        }
        // check if no area was selected (selectedTimeline is null) but all the BookingTypesFilters in the bookingsTypes
        if (Object.isObjectEmpty(selectedTimeline)) {
            setBookingsTypes(tempBookingsTypes);
            dispatch(setBookingType(["all"]))
        } else {
            // if the selected area (selectedTimeline) is for arrivals show only arrivals 
            if (selectedTimeline?.arrivals === true && selectedTimeline?.departures !== true) {
                setBookingsTypes([{ label: "Arrivals", value: "arrivals" }]);
            } else if (selectedTimeline?.arrivals !== true && selectedTimeline?.departures === true) {
                // if the selected area (selectedTimeline) is for departures show departures, checked in, ALTpickups
                setBookingsTypes([
                    { label: "Departures", value: "departures" },
                    { label: "ALT Pick Up", value: "ALTPickUp" },
                    { label: "Checked In", value: "checkedIn" }]);

            } else {
                // show all filters
                setBookingsTypes(tempBookingsTypes);
                dispatch(setBookingType(["all"]))
            }
        }

    }, [selectedTimeline, preBoard, rampBookings]);
    // edit placeholder depend on bookSearchFilter type (passenger,flight)

    //#region redux
    //#region functions
    const formatLastUpdate = (date = new Date()) => {
        return moment(date).format("HH:mm:ss")
    };

    // modal open handler
    const handleAddEmployee = () => {
        setShowAddModal(true); // show modal
    };

    // modal close handler
    const handleCloseModal = () => {
        dispatch(resetAddEmployeeForm()); // reset form for next use
        setShowAddModal(false); // close modal
    };

    // filter the previewed booking by the type (all, departures, arrivals and ALTPikcUp)
    const changeBookingTypeFilter = (selectedValue) => {
        if (Array.isFullArray(selectedValue)) {
            dispatch(setBookingType(selectedValue?.map((value) => value?.value)));
        } else dispatch(setBookingType(["all"]));
    };

    const createBookingTypeFilterObj = () => {
        let appliedFilter = BookingTypesFilters.filter((type) => bookingType?.includes(type?.value));
        return Array.isFullArray(appliedFilter) ? appliedFilter : []
    };
    //#endregion


    useInterval(async () => {
        props?.handelGetBookings();
        props?.handelGetFlights();
        setLastUpdate(new Date());
    }, 60000);

    return (
        <div style={{ width: "100%", display: 'flex', justifyContent: 'space-between', flex: 1 }}>

            {/* pagination */}
            {props?.hideEmployeePagination ? null :
                <div style={{ justifyContent: "flex-start", display: "flex", alignItems: "center", flex: 3 }}>
                    <PaginationV2 />
                    <FaCirclePlus onClick={handleAddEmployee} style={{ cursor: "pointer", marginBottom: Spacing.SCALE_10 }} className='mt-2' color={usedTheme.JOB_LIST_COLOR} size={24} data-tippy-content="Add Employee" />
                </div>
            }

            {/* filter */}
            {props?.hideFlightFilter ? null :
                <div style={{ display: 'flex', flex: 1, justifyContent: "flex-end" }}>

                    {/* select job filter */}
                    <div style={{ flex: 5 }} data-tippy-content="Filter by flight">
                        <Select
                            options={bookingsTypes}
                            placeholder="Displayed bookings..."
                            onChange={(selection) => changeBookingTypeFilter(selection)}
                            value={createBookingTypeFilterObj()}
                            isDisabled={selectedTimeline?.arrivals === true && selectedTimeline?.departures !== true}
                            isMulti={true}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    backgroundColor: usedTheme.BACKGROUND_COLOR,
                                    borderColor: usedTheme.BORDER_COLOR,
                                    color: usedTheme.TEXT_COLOR,
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    color: usedTheme.TEXT_COLOR,
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    color: usedTheme.TEXT_COLOR,
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 4,
                                    backgroundColor: usedTheme.BACKGROUND_COLOR,
                                    borderColor: usedTheme.BORDER_COLOR,
                                    color: usedTheme.TEXT_COLOR
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused
                                        ? usedTheme.BORDER_COLOR
                                        : usedTheme.BACKGROUND_COLOR,
                                    color: usedTheme.TEXT_COLOR,
                                    cursor: 'pointer',
                                }),
                            }}
                        />
                    </div>

                    {/* Flights Type filter */}
                    {SaudiDomesticAirports.includes(dbUser.details.authority) && <JobTypeDropdown />}
                    {/* refresh button */}
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        <Button variant={"primary"} onClick={() => { props.setShowCreateModal(true) }}
                            data-tippy-content="Add New Passenger"
                        >
                            <FaPlus color={'white'} size={Spacing.SCALE_16} />
                        </Button>
                    </div>

                    {/* refresh button */}
                    <div style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                        <Button variant={"primary"} onClick={() => {
                            props?.handelGetBookings();
                            props?.handelGetFlights();
                        }}
                            data-tippy-content="Refresh"
                        >
                            {/* loading spinner */}
                            {(getArrivalBookingsStatus === "loading" || getDepartureBookingStatus === "loading") ? <CustomSpinner size={'small'} variant={"light"} /> :

                                /* refresh icon */
                                <FiRefreshCcw color={'white'} size={Spacing.SCALE_16} />

                            }
                        </Button>
                    </div>

                </div>
            }


            <ActionsModal
                isTimeline={true}
                show={showAddModal}
                handleClose={handleCloseModal}
                title="Create Employee Account"
                subtitle={"To create an employee account enter the information below and click confirm"}
                minWidth="445px"
                maxWidth="445px"
            >
                <AddEmployeeForm closeModal={handleCloseModal} />
            </ActionsModal>
        </div>
    )

};

export default JobListToolbar;


